import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocoAlertModule } from '@app/soco/alert/alert_module';
import { SocoCommonModule } from '@app/soco/common/common_module';
import { SocoConfigurationModule } from '@app/soco/configuration/configuration_module';
import { SocoCoreModule } from '@app/soco/core/core_module';
import { SocoHttpModule } from '@app/soco/http/http_module';
import { SocoModalModule } from '@app/soco/modal/modal_module';

@NgModule({
  imports: [
    CommonModule,
    SocoAlertModule,
    SocoCommonModule,
    SocoConfigurationModule,
    SocoCoreModule,
    SocoHttpModule,
    SocoModalModule
  ],
  exports: [
    SocoAlertModule,
    SocoCommonModule,
    SocoConfigurationModule,
    SocoCoreModule,
    SocoHttpModule,
    SocoModalModule
  ]
})
export class SocoModule { }
